export default __webpack_public_path__ + "static/media/chuck-norris.9eb3434a.png";